<template>
  <div>
    <div id="bg"></div>
    <div id="wrap">
      <ul class="blind">
        <li>
          <a href="#contents">본문 바로가기(Skip Contents)</a>
        </li>
      </ul>

      <!-- //header -->
      <SubHeader title="Live Q&A" />
      <!-- //header -->
      <Gnb v-if="showGnb" />

      <div id="container" ref="container">
        <section id="contents">
          <div class="qnaWrap list-style" :style="bgStyle">
            <!-- point for changing color -->
            <div class="qnalistWrap">
              <div class="qnalistTitle">
                <div class="num">{{this.$store.getters.getQnaSubjectIndex}}</div>
                <div class="title">
                  <a href="#" @click.prevent>{{this.$store.getters.getQnaSubjectTitle}}</a>
                </div>
              </div>
              <!-- qnalistTitle -->
              <ul class="qnalistCon">
                <QnaItem :item="item" v-bind:key="item.id" v-for="item in items " />
              </ul>

              <div class="moreWrap" style="display:block;">
                <a v-if="canMore" href="#" class="more" @click.prevent="more">
                  더보기
                  <img src="@/assets/img/more_icon.png" alt="더보기" />
                </a>
                <a href="#" class="write" @click.prevent="gowrite">
                  <img src="@/assets/img/qnawrite.png" alt="글작성" />
                </a>
              </div>
            </div>

            <div class="btnWrap">
              <a href="#" class="type2" @click.prevent="changeOrderType">
                <img :src="ordertypeStyle" alt="공감순" />
                {{ordertypeText}}
              </a>
              <a href="#" @click.prevent="refresh">
                <img src="@/assets/img/reflash.png" alt="새로고침" />새로고침
              </a>
            </div>
          </div>
          <!-- qnaWrap -->
        </section>
        <!-- //contents -->
      </div>
      <!-- //container -->
    </div>
    <!-- //wrap -->
  </div>
</template>


<script>
import SubHeader from "@/components/SubHeaderWithHome";
import Gnb from "@/components/Gnb";
import router from "@/router";
import QnaItem from "@/components/qna/Item";
import sideMixin from "@/components/SideMixin";

export default {
  mixins: [sideMixin],
  components: { SubHeader, Gnb, QnaItem },
  created: function() {
    let paperid = this.$route.params.paperid;
    this.$store.dispatch("loadQnaMeta", paperid);
    this.$store.dispatch("loadQnaList", paperid);
  },
  computed: {
    canMore() {
      // console.log(this.$store.state.QnaItem);
      return this.$store.state.qna_totalpage > this.$store.state.qna_more_count;
    },
    bgStyle() {
      return `background-color:${this.$store.state.qna_bg}`;
    },
    showGnb: function() {
      return this.$store.getters.getShowGnb;
    },
    items: function() {
      return this.$store.getters.getQnaItems;
    },
    ordertypeText: function() {
      if (this.$store.getters.getQnaOrder === "favor") {
        return "공감순";
      } else {
        return "최신순";
      }
    },
    ordertypeStyle: function() {
      if (this.$store.getters.getQnaOrder === "favor") {
        return require("@/assets/img/sympathy.png");
      } else {
        return require("@/assets/img/new.png");
      }
    }
  },
  methods: {
    changeOrderType() {
      let paperid = this.$route.params.paperid;
      this.$store.dispatch("toggleQnaOrder");
      this.$store.dispatch("loadQnaList", paperid);
    },
    refresh() {
      let paperid = this.$route.params.paperid;
      this.$store.dispatch("loadQnaList", paperid);
    },
    more() {
      //rkCO0Pdy8
      let paperid = this.$route.params.paperid;
      this.$store.dispatch("loadQnaMore", paperid);
    },
    godetail(item) {
      let qnaid = item.id;
      this.$router.push(`/qna/detail/${qnaid}`);
    },
    gowrite() {
      let paperid = this.$route.params.paperid;
      this.$router.push(`/qna/write/${paperid}`);
    }
  }
};
</script>

